import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from './home'
import Common from './common'


Vue.use(VueRouter)




const router = new VueRouter({
  // mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    Home,
    Common
  ]
})




export default router
